function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 16,
  fill: "black",
  fillOpacity: 0.05
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_16602_120630)"
}, React.createElement("path", {
  d: "M17 22C17 23.657 19.686 25 23 25C26.314 25 29 23.657 29 22C29 20.343 26.314 19 23 19C19.686 19 17 20.343 17 22Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M17 22V26C17 27.656 19.686 29 23 29C26.314 29 29 27.656 29 26V22",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M11 14C11 15.072 12.144 16.062 14 16.598C15.856 17.134 18.144 17.134 20 16.598C21.856 16.062 23 15.072 23 14C23 12.928 21.856 11.938 20 11.402C18.144 10.866 15.856 10.866 14 11.402C12.144 11.938 11 12.928 11 14Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M11 14V24C11 24.888 11.772 25.45 13 26",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M11 19C11 19.888 11.772 20.45 13 21",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_16602_120630"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(8 8)"
})));

var SvgFinancialProductLight = function SvgFinancialProductLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFinancialProductLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/financial-product-light.8327d231.svg";
export { ForwardRef as ReactComponent };